const centerPanel = require('../../shop/views/center-panel.view.html').trim();

module.exports = function ($stateProvider) {
    $stateProvider
        .state('shop.cart', {
            url: '/cart',
            views: {
                'content@root': {
                    template: `${centerPanel}`,
                },
                'center-panel@shop.cart': {
                    template: '<wow-cart></wow-cart>',
                },
            },
            data: {
                pageMetadata: {
                    title: 'Shopping Cart - Woolworths Online',
                    metaDescription: 'Shopping Cart - Woolworths Online',
                    metaRobot: 'noindex',
                },
            },
        });
};



// WEBPACK FOOTER //
// ./src/configuration/routes/cart.js